"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var xtend = require("xtend");

/**
 * @module manage
 * @description  This module provides the functionality to the Web Portal for the
 * management of a Person by another Person.
 */

module.exports = function (config, get, post, upload) {
	picture.uri = picture_URI;

	return {
		permissions: {
			list: permissionList
		},
		requests: {
			send: send,
			cancel: cancel,
			accept: accept,
			deny: deny,
			incoming: incoming,
			outgoing: outgoing
		},
		steps: {
			add: add_stepcount,
			cumulative: cumulative,
			history: history
		},
		bloodsugar: {
			add: add_bloodsugar,
			history: get_bloodsugarhistory
		},
		weight: {
			add: add_weight,
			history: get_weighthistory
		},
		bloodpressure: {
			add: add_bloodpressure,
			history: get_bloodpressurehistory
		},
		bloodoxygen: {
			add: add_bloodoxygen,
			history: get_bloodoxygenhistory
		},
		bodytemperature: {
			add: add_bodytemperature,
			history: get_bodytemperature_history
		},
		status: {
			list: get_all_users_status
		},
		group: get_managee_group,
		list: list,
		listByStatus: listByStatus,
		listManagedUsers,
		listByCurrentStatus,
		remove: remove,
		picture: picture,
		update: update,
		data: data,
		managers: create_managers(config, get, post),
		contacts: create_contacts(config, get, post),
		reminders: create_reminders(config, get, post),
		device: create_device(config, get, post),
		atouchaway: create_atouchaway(config, get, post),
		urgency: createUrgency(config, get, post),
		manage: createManage(config, get, post),
		forms: createForms(config, get, post, upload),
		file: createFile(config, get, post, upload),
		careplan: createCareplan(config, get, post),
		metrics: createMetrics(config, get, post),
		updates: createUpdates(config, get, post),
		workflow: create_workflow(config, get, post),
		resources: create_resources(config, get, post),
		devices: create_devices(config, get, post),
		managegroup: create_managegroup(config, get, post),
		customIndicators: createCustomIndicators(config, get, post)
	};

	function get_all_users_status(managegroup) {
		return get("/v2/manage/status/list", {
			managegroup
		});
	}

	function get_managee_group(managee, managegroup) {
		return get("/v2/manage/group", {
			managee: managee,
			managegroup
		});
	}

	function add_bodytemperature(data) {
		return post("/v2/manage/observations/bodytemperature/record", {
			temperature: data.temperature,
			units: data.units,
			comment: data.comment,
			manual: data.manual,
			managee: data.managerId,
			managegroup: data.group
		});
	}

	/** Returns the managed user's body temperature history */
	function get_bodytemperature_history(user, managegroup) {
		return get("/v2/manage/observations/bodytemperature/history", {
			managee: user,
			managegroup
		});
	}

	function add_bloodoxygen(data) {
		return post("/v2/manage/observations/bloodoxygen/record", {
			pulserate: data.pulserate,
			oxygensaturation: data.oxygensaturation,
			comment: data.comment,
			oxygen: data.oxygen,
			exertion: data.exertion,
			manual: data.manual,
			managee: data.managerId,
			managegroup: data.group
		});
	}

	/** Returns the managed user's blood oxygen history */
	function get_bloodoxygenhistory(user, managegroup) {
		return get("/v2/manage/observations/bloodoxygen/history", {
			managee: user,
			managegroup

		});
	}

	function add_bloodpressure(data) {
		return post("/v2/manage/observations/bloodpressure/record", {
			systolic: data.systolic,
			diastolic: data.diastolic,
			bpPulserate: data.bpPulserate,
			comment: data.comment,
			manual: data.manual,
			managee: data.managerId,
			managegroup: data.group
		});
	}

	/** Returns the managed user's blood pressure history */
	function get_bloodpressurehistory(user, managegroup) {
		return get("/v2/manage/observations/bloodpressure/history", {
			managee: user,
			managegroup
		});
	}

	// Adds a new measurement to a user's weight history
	function add_weight(data) {
		return post("/v2/manage/observations/weight/record", {
			weight: data.weight,
			units: data.units,
			comment: data.comment,
			manual: data.manual,
			managee: data.managerId,
			managegroup: data.group
		});
	}

	/** Returns the managed user's weight history */
	function get_weighthistory(user, managegroup) {
		return get("/v2/manage/observations/weight/history", {
			managee: user,
			managegroup
		});
	}

	/** Returns the managed user's blood sugar history */
	function get_bloodsugarhistory(user, managegroup) {
		return get("/v2/manage/observations/bloodsugar/history", {
			managee: user,
			managegroup
		});
	}

	/**
 * A call to add a new bloodsugar reading to database
 */
	function add_bloodsugar(data) {
		return post("/v2/manage/observations/bloodsugar/record", {
			meanblood: data.meanblood,
			glucose: data.glucose,
			units: data.units,
			comment: data.comment,
			manual: data.manual,
			timestamp: data.timestamp,
			managee: data.managerId,
			managegroup: data.group
		});
	}

	/** Returns all the individual step count entries */
	function history(user, managegroup) {
		return get("/v2/manage/observations/steps/history", {
			managee: user,
			managegroup
		});
	}

	/** Returns the cumulative step reports */
	function cumulative(user, managegroup) {
		return get("/v2/manage/observations/steps/cumulative", {
			managee: user,
			managegroup
		});
	}

	function add_stepcount(data) {
		return post("/v2/manage/observations/steps/record", {
			value: data.value,
			timestamp: data.timestamp,
			comment: data.comment,
			manual: data.manual,
			managee: data.managerId,
			managegroup: data.group
		});
	}

	/**
	 * Returns a Manager's permissions for a given User
	 * @param  {String} user    ._id of user
	 * @return {Object}         Manager permissions for User
	 */
	function permissionList(user, managegroup) {
		return get("/v2/manage/permission/list", {
			user: user,
			managegroup
		});
	}

	/**
	 * Creates a management request to a Person
	 * @param  {String} token User's session token
	 * @param  {String} to    Id of user to send request to
	 * @return {Promise}      Resolves to request id and info
	 */
	function send(to) {
		return post("/v2/manage/request/send", {
			to: to
		});
	}

	/**
	 * Cancels a management request
	 * @param  {String} token   User's session token (optional)
	 * @param  {String} request ID of request to cancel
	 * @return {Promise}        Resolves if request was cancelled
	 */
	function cancel(request) {
		return post("/v2/manage/request/cancel", {
			request: request
		});
	}

	/**
	 * Accepts an management request
	 * @param  {String} token   User's session token (optional)
	 * @param  {String} request Id of the request to accept
	 * @return {Promise}        Resolves if request was accepted
	 */
	function accept(request) {
		return post("/v2/manage/request/accept", {
			request: request
		});
	}

	/**
	 * Denies a manage request
	 * @param  {String} token   User's session token (optional)
	 * @param  {String} request ID of request to deny
	 * @return {Promise}        Resovles if the request was denied
	 */
	function deny(request) {
		return post("/v2/manage/request/deny", {
			request: request
		});
	}

	/**
	 * Gets all the incoming manage requests
	 * @return {Promise} Resolves to array of requests
	 */
	function incoming() {
		return get("/v2/manage/request/incoming", {});
	}

	/**
	 * Gets all the outgoing management requests
	 * @return {Promise} Resolves to array of requests
	 */
	function outgoing() {
		return get("/v2/manage/request/outgoing", {});
	}

	/**
	 * Uploads a new profile picture for a managed person
	 * @param  {File}    file    Reference to picture's file
	 * @param  {String}  managee Id of managed person
	 * @param  {Object}  options Optional `crop` and `rotate` properties for cropping
	 * @return {Promise}         Resolves to something or other
	 */
	function picture(file, who, options, managegroup) {
		var payload = xtend(options || {}, {
			managee: who,
			managegroup
		});

		return upload("/v2/manage/picture", payload, "picture", file);
	}

	/**
	 * Uploads a new profile picture for a managed person using a data URI
	 * @param {String} uri     The data URI for a picture.
	 * @param {String} managee Id of the menaged person
	 */
	function picture_URI(uri, managee, managegroup) {
		return post("/v2/manage/picture/uri", {
			picture: uri,
			managee: managee,
			managegroup
		});
	}

	/**
	 * Updates a managed person's personal data
	 * @param  {Object}  data    The updates to the person's data
	 * @param  {String}  managee Id of managed person
	 * @return {Promise}         Resolves if updates were successful
	 */
	function update(payload, managee, managegroup) {
		return post("/v2/manage/update", {
			data: payload,
			managee: managee,
			managegroup
		});
	}

	/**
	 * Gets the full personal data of the managee
	 * @param  {String}  managee Id of managed person
	 * @return {Promsie}         Resolves to Object with personal data
	 */
	function data(managee, managegroup) {
		return get("/v2/manage/data", {
			managee,
			managegroup
		});
	}

	/**
	 * Gets the list of managed people
	 * @return {Promise} Resovles to array of managed person ids
	 */
	function list(managegroup, page, query) {
		return get("/v2/manage/list", {
			managegroup,
			page,
			query
		});
	}

	/**
	 * Gets the list of managed people sorted by current_status.
	 *
	 * @deprecated  use listByCurrentStatus instead
	 *
	 * @param   {String}  query    query string to filter on
	 * @param   {Number}  page     number of the page to retrieve
	 * @param   {Boolean} inactive inactive status of the user
	 * @returns {Promise}          Resolves to array of managed user ids matching filters.
	 */
	function listByStatus(query, page, inactive) {
		return get("/v2/manage/list/bystatus", {
			query,
			page,
			status: inactive,
		});
	}

	/**
	 * Gets the list of managed people sorted by current_status.
	 *
	 * If managegroup is provided, lists users in the manage group, else it lists users who are
 	 * managed by listOptions.manager.
	 * @param   {Object}         filters              filters to apply to the query
	 * @param   {String}        [filters.query]       query string to filter on
	 * @param   {Boolean}       [filters.status]      inactive state of the user
	 * @param   {String|Array}  [filters.state]       user state
	 * @param   {String}        [filters.managegroup] manage group to filter on
	 * @param   {Number}         page                 number of the page to retrieve
	 * @returns {Promise}                            Resolves to array of managed user ids matching filters.
	 */
	function listByCurrentStatus(filters = {}, page) {
		return get("/v2/manage/list/bystatus", {
			...filters,
			page,
		});
	}

	/**
	 * Lists managed user.
	 * @param   {Object}    filters               filters to apply to the query
	 * @param   {String}   [filters.queryString]  query string to filter on
	 * @param   {Boolean}  [filters.inactive]     inactive state of the user
	 * @param   {String[]} [filters.state]        user states to filter on
	 * @param   {String[]} [filters.manageGroups] manage group to filter on
	 * @param   {Number}   [pagination.page]      page number
	 * @param   {String}   [pagination.sortBy]    field to sort on
	 * @param   {String}   [pagination.orderBy]   "asc" to "desc", defaults to asc
	 * @returns {Promise}                         Resolves to array of managed user ids matching filters.
	 */
	function listManagedUsers(filters = {}, pagination = {}) {
		return get("/v2/manage/managed/users", {
			...filters,
			...pagination,
		});
	}

	/**
	 * Removes a person from the managed list
	 * @param  {String}  managee Id of managed person to remove
	 * @return {Promise}         Resolves if removal was successful
	 */
	function remove(who) {
		return post("/v2/manage/list/remove", {
			who: who
		});
	}
};

function create_contacts(config, get, post) {
	return {
		requests: {
			request: request,
			cancel: cancel,
			accept: accept,
			deny: deny,
			incoming: incoming,
			outgoing: outgoing
		},
		invite: {
			request: invite_request,
			cancel: invite_cancel,
			list: invite_list
		},
		list: list,
		remove: remove
	};

	/**
	 * Lists managed person's contacts
	 * @param  {String}  managee Id of the managed person
	 * @return {Promise}         Resovles to array of contact ids
	 */
	function list(managee, managegroup) {
		return get("/v2/manage/contacts/list", {
			managee: managee,
			managegroup
		});
	}

	/**
	 * Removes a contact from a managed person's list
	 * @param  {String}  who     Id of contact to remove
	 * @param  {String}  managee Id of the managed person
	 * @return {Promise}         Resolves if removal succeeds
	 */
	function remove(who, managee, managegroup) {
		return post("/v2/manage/contacts/list/remove", {
			who: who,
			managee: managee,
			managegroup
		});
	}

	/**
	 * Lists managed person's incoming contact requests
	 * @param  {String}  managee Id of managed person
	 * @return {Promise}         Resolves to array of requests
	 */
	function incoming(managee, managegroup) {
		return get("/v2/manage/contacts/requests/incoming", {
			managee: managee,
			managegroup
		});
	}

	/**
	 * Lists managed person's outgoing contact requests
	 * @param  {String}  managee Id of managed person
	 * @return {Promise}         Resovles to array of requests
	 */
	function outgoing(managee, managegroup) {
		return get("/v2/manage/contacts/requests/outgoing", {
			managee: managee,
			managegroup
		});
	}

	/**
	 * Creates a contact requests from the managed person to another person
	 * @param  {String} to       Id of person to send the request to
	 * @param  {String} managee  Id of managed person
	 * @return {Promise}         Resovles to request information
	 */
	function request(to, managee, managegroup) {
		return post("/v2/manage/contacts/request", {
			to: to,
			managee: managee,
			managegroup
		});
	}

	/**
	 * Cancel a managed person's outgoing contact request
	 * @param  {String}  request Id of the request to cancel
	 * @param  {String}  managee id of managed person
	 * @return {Promise}         Resolves if cancellation succeeds
	 */
	function cancel(requestID, managee, managegroup) {
		return post("/v2/manage/contacts/request/cancel", {
			request: requestID,
			managee: managee,
			managegroup
		});
	}

	/**
	 * Accepts a managed person's incoming contact request
	 * @param  {String}  request Id of the request to accept
	 * @param  {String}  managee Id of managed person
	 * @return {Promise}         Resolves if accepting succeeds
	 */
	function accept(requestID, managee, managegroup) {
		return post("/v2/manage/contacts/request/accept", {
			request: requestID,
			managee: managee,
			managegroup
		});
	}

	/**
	 * Denies a managed person's incoming contact request
	 * @param  {String}  request Id of the request to deny
	 * @param  {String}  managee Id of the managed person
	 * @return {Promsie}         Resolves if denying succeeds
	 */
	function deny(requestID, managee, managegroup) {
		return post("/v2/manage/contacts/request/deny", {
			request: requestID,
			managee: managee,
			managegroup
		});
	}

	function invite_request(managee, email, language, managegroup) {
		return post("/v2/manage/contacts/invite", {
			managee: managee,
			email: email,
			language: language,
			managegroup
		});
	}

	function invite_cancel(managee, invite, managegroup) {
		return post("/v2/manage/contacts/invite/cancel", {
			managee: managee,
			invite: invite,
			managegroup
		});
	}

	function invite_list(managee, managegroup) {
		return get("/v2/manage/contacts/invite/list", {
			managee: managee,
			managegroup
		});
	}
}

/**
 * Creates the API for reminders
 * @param  {Object}   config The config object used to create the main API
 * @param  {Function} get    The function used to create GET requests to the API
 * @param  {Function} post   The function used to create POST requests to the API
 * @return {Object}          Returns map of API methods
 */
function create_reminders(config, get, post) {
	return {
		list: list,
		add: add,
		remove: remove,
		edit: edit,
		history: {
			pending: list_pending_history,
			clear: clear_history,
			listall: list_all_reminders,
		}
	};

	/**
	 * Gets the list of reminders for a managed person
	 * @param  {String}  managee Id of the person to get reminders from
	 * @return {Promise}         Resolves to array of reminder objects
	 */
	function list(managee, managegroup) {
		return get("/v2/manage/reminders/list", {
			managee: managee,
			managegroup
		});
	}

	/**
		 * [listall description]
		 * @param {[type]} page  [description]
		 * @param {[type]} managee_id [description]
		 */
	function list_all_reminders(page, managee_id, managegroup) {
		return get("/v2/manage/reminders/history/list/all", {
			page: page,
			managee: managee_id,
			managegroup
		});
	}


	/**
	 * Adds a new reminder for a managed person
	 * @param  {String}  managee  Id of the person to add the reminder to
	 * @param  {String}  content  The content the reminder should display
	 * @param  {String}  schedule The CRON string for the schedule. Optional
	 * @return {Promise}          Resolves if addition was successful
	 */
	function add(managee, content, schedule, notification, type, managegroup) {
		return post("/v2/manage/reminders/add", {
			managee: managee,
			content: content,
			schedule: schedule || undefined,
			notification: notification,
			type: type,
			managegroup
		});
	}

	/**
	 * Removes a reminder from a maanged person
	 * @param  {String}  managee  Id of the person to remove the reminder from
	 * @param  {String}  reminder Id of the reminder to remove
	 * @return {Promise}          Resolves if the reminder got removed succssfully
	 */
	function remove(managee, reminder, managegroup) {
		return post("/v2/manage/reminders/remove", {
			managee: managee,
			reminder: reminder,
			managegroup
		});
	}

	/**
	 * Edits an existing reminder of a managed person
	 * @param  {String}  managee  The id of the managed person
	 * @param  {String}  reminder The id of the reminder to edit
	 * @param  {String}  content  The new content to use for the reminder
	 * @param  {String}  schedule The new CRON schedule for the reminder
	 * @return {Promise}          Resolves if the reminder has been updated succssfully
	 */
	function edit(managee, reminder, content, schedule, notification, type, managegroup) {
		return post("/v2/manage/reminders/edit", {
			managee: managee,
			content: content,
			reminder: reminder,
			schedule: schedule || undefined,
			notification: notification,
			type: type,
			managegroup
		});
	}

	function list_pending_history(managee, managegroup) {
		return get("/v2/manage/reminders/history/list/pending", {
			managee: managee,
			managegroup
		});
	}

	function clear_history(managee, reminder, managegroup) {
		return post("/v2/manage/reminders/history/clear", {
			managee: managee,
			reminder: reminder,
			managegroup
		});
	}
}

function create_device(config, get, post) {
	return {
		data: device_data,
		associate: associate_device,
		unassociate: unassociate_device,
		contact: set_device_contact,
		update: update_device
	};

	function device_data(managee, managegroup) {
		return get("/v2/manage/device/data", {
			managee: managee,
			managegroup
		});
	}

	function associate_device(managee, mac, managegroup) {
		return post("/v2/manage/device/associate", {
			managee: managee,
			mac: mac,
			managegroup
		});
	}

	function unassociate_device(managee, managegroup) {
		return post("/v2/manage/device/unassociate", {
			managee: managee,
			managegroup
		});
	}

	function set_device_contact(managee, contact, managegroup) {
		return post("/v2/manage/device/contact", {
			managee: managee,
			contact: contact,
			managegroup
		});
	}

	function update_device(managee, data, managegroup) {
		return post("/v2/manage/device/update", xtend(data, {
			managee: managee,
			managegroup
		}));
	}
}

function create_atouchaway(config, get, post) {
	return {
		data: atouchaway_data,
		update: update_atouchaway
	};

	function atouchaway_data(managee, managegroup) {
		return get("/v2/manage/atouchaway/data", {
			managee: managee,
			managegroup
		});
	}

	function update_atouchaway(managee, data, managegroup) {
		return post("/v2/manage/atouchaway/update", xtend(data, {
			managee: managee,
			managegroup
		}));
	}
}

function createUrgency(config, get, post) {
	return {
		list: list_urgency_contacts,
		add: add_urgency_contact,
		remove: remove_urgency_contact,
		preferences: {
			get: get_urgency_preferences,
			update: update_urgency_preferences
		}
	};

	function get_urgency_preferences(managee, managegroup) {
		return get("/v2/manage/urgency/preferences/data", {
			managee: managee,
			managegroup
		});
	}

	function update_urgency_preferences(managee, updates, managegroup) {
		var data = xtend(updates, {
			managee: managee,
			managegroup
		});
		return post("/v2/manage/urgency/preferences/update", data);
	}

	function list_urgency_contacts(managee, managegroup) {
		return get("/v2/manage/urgency/list", {
			managee: managee,
			managegroup
		});
	}

	function add_urgency_contact(managee, contact, managegroup) {
		return post("/v2/manage/urgency/add", {
			managee: managee,
			who: contact,
			managegroup
		});
	}

	function remove_urgency_contact(managee, contact, managegroup) {
		return post("/v2/manage/urgency/remove", {
			managee: managee,
			who: contact,
			managegroup
		});
	}
}

function createManage(config, get, post) {
	return {
		list: list_managers,
		permissions: {
			list: permissions_list,
			update: permissions_update,
			default: permissions_default,
			presets: permissions_presets
		},
		remove: remove_manager,
		request: {
			list: managee_request_list,
			send: manager_request_send,
			sendBulk: manager_request_send_bulk,
			cancel: manager_request_cancel
		},
		invite: {
			send: manager_invite_send,
			sendBulk: manager_invite_send_bulk,
			list: manager_invite_list,
			cancel: manager_invite_cancel
		}
	};

	function managee_request_list(managee, managegroup) {
		return get("/v2/manage/manage/manager/request/list", {
			managee: managee,
			managegroup
		});
	}

	function manager_request_send_bulk(managee, managerList, permissions, managegroup) {
		return post("/v2/manage/manage/manager/request/sendbulk", {
			managee: managee,
			managerList: managerList,
			permissions: permissions,
			managegroup
		});
	}

	function manager_request_send(managee, manager, permissions, managegroup) {
		return post("/v2/manage/manage/manager/request/send", {
			managee: managee,
			manager: manager,
			permissions: permissions,
			managegroup
		});
	}

	function manager_request_cancel(managee, request, managegroup) {
		return post("/v2/manage/manage/manager/request/cancel", {
			managee: managee,
			request: request,
			managegroup
		});
	}

	function manager_invite_send(managee, email, language, permissions, managegroup) {
		return post("/v2/manage/manage/manager/invite/send", {
			managee: managee,
			email: email,
			language: language,
			permissions: permissions,
			managegroup
		});
	}

	function manager_invite_send_bulk(managee, list, permissions, managegroup) {
		return post("/v2/manage/manage/manager/invite/sendbulk", {
			managee: managee,
			emailList: list,
			permissions: permissions,
			managegroup
		});
	}

	function manager_invite_cancel(managee, invite, managegroup) {
		return post("/v2/manage/manage/manager/invite/cancel", {
			managee: managee,
			invite: invite,
			managegroup
		});
	}

	function manager_invite_list(managee, managegroup) {
		return get("/v2/manage/manage/manager/invite/list", {
			managee: managee,
			managegroup
		});
	}

	function list_managers(managee, managegroup) {
		return get("/v2/manage/manage/list", {
			managee: managee,
			managegroup
		});
	}

	function remove_manager(managee, manager, managegroup) {
		return post("/v2/manage/manage/remove", {
			managee: managee,
			manager: manager,
			managegroup
		});
	}

	function permissions_list(managee, manager, managegroup) {
		return get("/v2/manage/manage/permissions/list", {
			managee: managee,
			manager: manager,
			managegroup
		});
	}

	function permissions_update(managee, manager, permissions, managegroup) {
		return post("/v2/manage/manage/permissions/update", {
			managee: managee,
			manager: manager,
			permissions: permissions,
			managegroup
		});
	}

	function permissions_default(managee, managegroup) {
		return get("/v2/manage/manage/permissions/default", {
			managee: managee,
			managegroup
		});
	}

	function permissions_presets(managee, managegroup) {
		return get("/v2/manage/manage/permissions/presets", {
			managee: managee,
			managegroup
		});
	}
}

function createForms(config, get, post, upload) {
	return {
		submission: {
			core: submit_core_form,
			list: list_managed_submissions,
			update: update_form_submission,
			remove: remove_form_submission,
			group: {
				create: create_user_submission,
				update: update_user_submission,
				lock: lock_user_submission,
				remove: remove_user_submission,
				search: search_user_submission,
				prepopulate: fetch_prepopulate,
				file: upload_file_submission
			}
		},
		survey: {
			send: send_survey
		},
		listGroup: list_group_forms
	};

	function upload_file_submission(managee, file, managegroup) {
		return upload("/v2/manage/forms/submission/group/file", {
			managee: managee,
			managegroup
		}, "file", file);
	}

	function send_survey(managee, survey, managegroup) {
		return post("/v2/manage/surveys/send", {
			managee: managee,
			survey: survey,
			managegroup
		});
	}

	function update_form_submission(managee, submission, data, managegroup) {
		return post("/v2/manage/forms/submission/update", {
			managee: managee,
			submission: submission,
			data: data,
			managegroup
		});
	}

	function remove_form_submission(managee, submission, managegroup) {
		return post("/v2/manage/forms/submission/remove", {
			managee: managee,
			submission: submission,
			managegroup
		});
	}

	function submit_core_form(managee, name, data, managegroup) {
		return post("/v2/manage/forms/submission/core", {
			managee: managee,
			name: name,
			data: data,
			managegroup
		});
	}

	function list_managed_submissions(managee, page, managegroup) {
		return get("/v2/manage/forms/submission/list", {
			managee: managee,
			page: page,
			managegroup
		});
	}

	function list_group_forms(managee, managegroup) {
		return get("/v2/manage/forms/list/group", {
			managee: managee,
			managegroup
		});
	}

	function create_user_submission(managee, form, managegroup, data) {
		return post("/v2/manage/forms/submission/group/create", {
			managee: managee,
			form: form,
			data: data,
			managegroup
		});
	}

	function update_user_submission(managee, submission, managegroup, data) {
		return post("/v2/manage/forms/submission/group/update", {
			managee: managee,
			submission: submission,
			data: data,
			managegroup
		});
	}

	function remove_user_submission(managee, submission, managegroup
	) {
		return post("/v2/manage/forms/submission/group/remove", {
			managee: managee,
			submission: submission,
			managegroup
		});
	}

	function lock_user_submission(managee, submission, managegroup) {
		return post("/v2/manage/forms/submission/group/lock", {
			managee: managee,
			submission: submission,
			managegroup
		});
	}

	function search_user_submission(managee, form, start, end, page, managegroup, editorList) {
		return get("/v2/manage/forms/submission/group/search", {
			managee: managee,
			form: form,
			start: start,
			end: end,
			page: page,
			managegroup,
			editorList
		});
	}

	
	function fetch_prepopulate(managee, form, managegroup) {
		return get("/v2/manage/forms/submission/group/prepopulate", {
			managee: managee,
			form: form,
			managegroup
		});
	}

}

function createFile(config, get, post, upload) {
	return {
		upload: upload_file,
		list: list_files,
		data: file_data,
		delete: delete_file
	};

	function upload_file(file, managee, managegroup) {
		return upload("/v2/manage/file/upload", {
			managee: managee,
			managegroup
		}, "file", file);
	}

	function list_files(managee, managegroup) {
		return get("/v2/manage/file/list", {
			managee: managee,
			managegroup
		});
	}

	function file_data(managee, file, managegroup) {
		return get("/v2/manage/file/data", {
			managee: managee,
			file: file,
			managegroup
		});
	}

	function delete_file(managee, file, managegroup) {
		return post("/v2/manage/file/delete", {
			managee: managee,
			file: file,
			managegroup
		});
	}
}

function createMetrics(config, get, post) {
	return {
		cumulative: cumulative,
		add: add,
	};

	function cumulative(managee, managegroup) {
		return get("/v2/manage/metrics/cumulative", {
			managee: managee,
			managegroup
		});
	}

	function add(managee, metric, managegroup) {
		return post("/v2/manage/metrics/create", {
			managee: managee,
			metric: metric,
			managegroup
		});
	}
}

function createCareplan(config, get, post) {
	return [
		"Appointments",
		"CareTeam",
		"Client",
		"DocumentControl",
		"Goals",
		"HealthAssessments",
		"HealthConditions",
		"HospitalVisits",
		"OtherTreatments",
		"Situation",
		"Supports",
		"Treatments"
	].reduce(function (result, section) {
		var lowerSection = section.toLowerCase();
		result[lowerSection] = {
			data: getSectionData,
			changes: {
				proposed: {
					add: addProposedChange
				},
				pending: {
					list: listPendingChanges,
				},
				confirmed: {
					add: confirmProposedChange,
				},
				denied: {
					add: denyProposedChange
				}
			}
		};

		return result;

		function confirmProposedChange(managee, change, managegroup) {
			return post("/v2/manage/careplan/" + lowerSection + "/changes/confirmed/add", {
				managee: managee,
				change: change,
				managegroup
			});
		}

		function denyProposedChange(managee, change, managegroup) {
			return post("/v2/manage/careplan/" + lowerSection + "/changes/denied/add", {
				managee: managee,
				change: change,
				managegroup
			});
		}

		function listPendingChanges(managee, managegroup) {
			return get("/v2/manage/careplan/" + lowerSection + "/changes/pending/list", {
				managee: managee,
				managegroup
			});
		}

		function addProposedChange(managee, changes, managegroup) {
			return post("/v2/manage/careplan/" + lowerSection + "/changes/proposed/add", {
				managee: managee,
				changes: changes,
				managegroup
			});
		}

		function getSectionData(managee, managegroup) {
			return get("/v2/manage/careplan/" + lowerSection + "/data", {
				managee: managee,
				managegroup
			});
		}
	}, {});
}

function createUpdates(config, get) {
	return {
		list: list_updates
	};

	function list_updates(managee, managegroup) {
		return get("/v2/manage/updates/list", {
			managee: managee,
			managegroup
		});
	}
}

function create_managers(config, get, post) {
	return {
		list: list_managers,
		permission: {
			list: get_permissions,
			update: update_permissions,
		},
		remove: remove_manager,
	};

	function list_managers() {
		return get("/v2/manage/managers/list");
	}

	function get_permissions(manager) {
		return get("/v2/manage/managers/permission/list", {
			manager: manager
		});
	}

	function update_permissions(manager, permissions) {
		return post("/v2/manage/managers/permission/update", {
			manager: manager,
			permissions: permissions
		});
	}

	function remove_manager(manager) {
		return post("/v2/manage/managers/remove", {
			manager: manager
		});
	}
}

function create_workflow(config, get, post) {
	return {
		definitions: workflow_definitions,
		ongoing: ongoing_workflows,
		actions: workflow_actions,
		history: finished_workflows,
		create: start_workflow,
		finish: finish_workflow,
		update: update_workflow,
		actors: {
			add: add_actor,
			remove: remove_actor
		}
	};

	function workflow_definitions(managee, managegroup) {
		return get("/v2/manage/workflow/definitions", {
			managee: managee,
			managegroup
		});
	}

	function ongoing_workflows(managee, managegroup) {
		return get("/v2/manage/workflow/ongoing", {
			managee: managee,
			managegroup
		});
	}

	function workflow_actions(page, managee, workflow, managegroup) {
		return get("/v2/manage/workflow/actions", {
			page: page || 0,
			managee: managee,
			workflow: workflow,
			managegroup
		});
	}

	function finished_workflows(page, managee, managegroup) {
		return get("/v2/manage/workflow/history", {
			page: page,
			managee: managee,
			managegroup
		});
	}

	function start_workflow(managee, label, workflow, actors, defaults, managegroup) {
		return post("/v2/manage/workflow/create", {
			managee: managee,
			label: label,
			workflow: workflow,
			actors: actors,
			defaults: defaults,
			managegroup
		});
	}

	function finish_workflow(managee, workflow, managegroup) {
		return post("/v2/manage/workflow/finish", {
			managee: managee,
			workflow: workflow,
			managegroup
		});
	}

	function add_actor(managee, workflow, actor, who, managegroup, type) {
		return post("/v2/manage/workflow/actors/add", {
			managee: managee,
			workflow: workflow,
			actor: actor,
			who: who,
			managegroup,
			type
		});
	}

	function remove_actor(managee, workflow, actor, who, managegroup, type) {
		return post("/v2/manage/workflow/actors/remove", {
			managee: managee,
			workflow: workflow,
			actor: actor,
			who: who,
			managegroup,
			type
		});
	}

	function update_workflow(managee, workflow, data, managegroup) {
		return post("/v2/manage/workflow/update", {
			managee: managee,
			workflow: workflow,
			data: data,
			managegroup
		});
	}
}

function create_resources(config, get, post) {
	return {
		list: list,
		all: all,
		set: set,
		saveViewed: saveViewed
	};

	function list(who, managegroup) {
		return get("/v2/manage/resources/list", {
			who: who,
			managegroup
		});
	}

	function all(who, managegroup) {
		return get("/v2/manage/resources/all", {
			who: who,
			managegroup
		});
	}

	function set(who, resources, managegroup) {
		return post("/v2/manage/resources/set", {
			who: who,
			resources: resources,
			managegroup
		});
	}

	function saveViewed(managee, resourceId){
		return post("/v2/manage/resources/analytic", {
			managee,
			resourceId
		});
	}
}

function create_devices(config, get, post) {
	return {
		list: list,
		add: add,
		update: update,
		remove: remove
	};

	function list(managee, managegroup) {
		return get("/v2/manage/devices/list", {
			managee: managee,
			managegroup
		});
	}

	function add(device, managee, managegroup) {
		return post("/v2/manage/devices/add", {
			managee: managee,
			device: device,
			managegroup
		});
	}

	function update(device, managee, managegroup) {
		return post("/v2/manage/devices/update", {
			managee: managee,
			device: device,
			managegroup
		});
	}

	function remove(device, managee, managegroup) {
		return post("/v2/manage/devices/remove", {
			managee: managee,
			device: device,
			managegroup
		});
	}
}

function create_managegroup(config, get) {
	return {
		list: list,
		permissions: permissions,
		listManagers: listManagers,
		listManagedPatientGroups: (managee, managegroup) => get("/v2/manage/managegroup/list/patient/groups", {
			managee,
			managegroup
		})
	};

	function list() {
		return get("/v2/manage/managegroup/list");
	}

	function permissions(group) {
		return get("/v2/manage/managegroup/permissions", {
			group: group
		});
	}

	function listManagers(group) {
		return get("/v2/manage/managegroup/list/managers", {
			group: group
		});
	}
}

function createCustomIndicators(config, get, post) {
	return {
		listAll: listAll,
		history: history,
		record: record
	};

	function listAll(managee, managegroup) {
		return get("/v2/manage/observations/indicators", {
			managee: managee,
			managegroup: managegroup
		});
	}

	function history(indicatorId, managee, managegroup) {
		return get(`/v2/manage/observations/indicators/${indicatorId}/history`, {
			managee: managee,
			managegroup: managegroup
		});
	}

	function record(indicatorId, value, comment, managee, managegroup) {
		return post(`/v2/manage/observations/indicators/${indicatorId}/record`, {
			value: value,
			comment: comment,
			managee: managee,
			managegroup: managegroup
		});
	}
}
